// French translation
const fr = {
  "hotel.booking.number": "Numéro",
  "hotel.booking.party": "Titulaire",
  "hotel.booking.contact": "Contact",
  "hotel.booking.bill_to": "Facturer à",
  "hotel.booking.bill.all": "Tout",
  "hotel.booking.bill.partial": "Partiel",
  "hotel.booking.booking_date": "Date de réservation",
  "hotel.booking.total_amount": "Montant",
  "hotel.booking.total_advances": "Total des acomptes",
  "hotel.booking.lines": "Nb. chambres",
  "hotel.booking.media": "Canal",
  "hotel.booking.meal_plan": "Régime alimentaire",
  "hotel.booking.space": "Espace",
  "hotel.booking.price_list": "Liste de prix",
  "hotel.booking.payment_term": "Délai de paiement",
  "hotel.booking.rate_plan": "Plan tarifaire",
  "hotel.booking.pending_to_pay": "Montant restant à payer",
  "hotel.booking.group": "Groupe",
  "hotel.booking.corporative": "Entreprise",
  "hotel.booking.state": "Statut",
  "hotel.booking.offer": "Offre",
  "hotel.booking.complimentary": "Offert",
  "hotel.booking.confirm": "Confirmer",
  "hotel.booking.cancelled": "Annulé",
  "hotel.booking.no_show": "Non présenté",
  "hotel.booking.block": "Bloquer",
  "hotel.booking.finished": "Terminé",
  "hotel.booking": "RÉSERVATION",
  "hotel.booking.today": "Aujourd’hui",
  "hotel.booking.confirmed": "Confirmée",
  "hotel.booking.bill": "Facturer",
  "hotel.booking.channel": "Canal",
  "hotel.booking.ota_booking_code": "Code OTA",
  "hotel.booking.agent": "Agent",
  "hotel.booking.notes": "Notes",
  "hotel.booking.advances_payments": "Acomptes / Paiements",
  "hotel.booking.invoices": "Factures",
  "hotel.booking.notifications": "Notifications",
  "hotel.booking.pax": "PAX",
  "hotel.booking.taxes_exception": "Exonération de TVA",
  "hotel.booking.holder": "Titulaire",
  "hotel.booking.holder_guest": "Titulaire / Client",
  "hotel.booking.guest": "Client",
  "hotel.booking.blocked": "Bloqué",
  "hotel.folio": "FOLIO",
  "hotel.booking.lead_origin": "Origine",
  "hotel.folio.overbooking": "Surréservation",
  "hotel.folio.accept": "Accepter",
  "hotel.booking.add_rooms": "Ajouter une chambre",
  "hotel.booking.add_rooms.accept": "Accepter",
  "hotel.booking_statement": "PRÉ-COMPTE",
  "hotel.booking.plan+rate": "Plan + tarifs hors taxes",
  "hotel.booking.fees_taxes_not_included": "FRAIS ET TAXES NON INCLUS",
  "hotel.booking.msg_iva_foreign":
    "TVA non incluse pour les étrangers, sous réserve de vérification du passeport et de la carte migratoire lors du check-in.",
  "hotel.booking.msg_iva": "TVA incluse à 19%.",
  "hotel.booking.i_foreigner": "Je suis étranger",
  "hotel.booking.i_colombiano": "Je suis colombien",
  "hotel.booking.add_rooms.selector.product": "Catégorie",
  "hotel.booking.add_rooms.selector.unit_price_w_tax": "Tarif",
  "hotel.booking.add_rooms.selector.available": "Disponibles",
  "hotel.booking.add_rooms.selector.adults": "Adultes",
  "hotel.booking.add_rooms.selector.children": "Enfants",
  "hotel.booking.add_rooms.selector.room": "Ch.",
  "hotel.booking.add_rooms.selector.add": "Ajouter",
  "hotel.booking.add_rooms.selector.sale_price_taxed": "Prix",
  "hotel.booking.add_rooms.selector.discount": "Remise",
  "hotel.booking.add_rooms.nights_quantity": "Nuits",
  "hotel.booking.add_payment": "Acompte / Paiement",
  "hotel.booking.add_payment.amount": "Montant",
  "hotel.booking.add_payment.voucher": "Justificatif",
  "hotel.booking.add_payment.statement": "Moyen de paiement",
  "hotel.booking.add_payment.pay": "Payer",
  "hotel.booking.add_room.arrival_date": "Arrivée",
  "hotel.booking.add_room.departure_date": "Départ",
  "hotel.booking.add_room.nights_quantity": "Nuits",
  "hotel.booking.add_rooms.selector.rooms": "Ch.",
  "hotel.chart.occupation_room": "Occupation des chambres",
  "hotel.chart.occupation_today": "Aujourd’hui",
  "hotel.chart.occupation_tomorrow": "Demain",
  "hotel.chart.check_in_today": "Arrivées aujourd’hui",
  "hotel.chart.check_out_today": "Départs aujourd’hui",
  "hotel.chart.occupation_rate": "Taux d’occupation",
  "hotel.chart.occupation_rate_today": "Aujourd’hui",
  "hotel.chart.occupation_rate_tomorrow": "Demain",
  "hotel.booking.bill.party": "Tiers",
  "hotel.booking.bill.kind": "Type",
  "hotel.booking.bill.bill": "Facturer",
  "hotel.booking.bill.add_guest": "Ajouter un client",
  "hotel.booking.bill.add_vehicle_plate": "Ajouter une plaque",
  "hotel.booking.wiz_payment.voucher": "Justificatif",
  "hotel.booking.wiz_payment.statement": "Moyen de paiement",
  "hotel.booking.wiz_payment.amount": "Montant",
  "hotel.booking.wiz_payment.notes": "Notes",
  "booking.widget_side.today": "Aujourd’hui",
  "booking.widget_side.tomorrow": "Demain",
  "booking.widget_side_status.revenue_today": "Revenu aujourd’hui",
  "hotel.booking.wiz_payment.button_pay": "Payer",
  "hotel.booking.undefined": "Indéfini",
  "hotel.booking.environment": "Environnement",
  "hotel.booking.update_taxes": "Mettre à jour les taxes",
  "hotel.booking.update_taxes.start.accept": "Accepter",
  "hotel.booking.update_taxes.start.taxes": "Taxes",
  "hotel.booking.apply_taxes_exception": "Exonération de TVA",
  "hotel.booking.add_rooms.selector.accommodation": "Type d’hébergement",
  "hotel.booking.add_rooms.selector.availability": "Disponibilité",
  "hotel.booking.whitout.rooms":
    "Aucune chambre n’est disponible pour les dates sélectionnées",
  "hotel.booking.kids.policy": "Politique enfants",
};

export default fr;
